import PropTypes from 'prop-types';
import React from 'react';

import GracePeriodSummary from 'components/alertconditions/GracePeriodSummary';
import BacklogSummary from 'components/alertconditions/BacklogSummary';
import RepeatNotificationsSummary from 'components/alertconditions/RepeatNotificationsSummary';
import { Pluralize } from 'components/common';

class MessageCountConditionSummary extends React.Component {
  static propTypes = {
    alertCondition: PropTypes.object.isRequired,
  };

  render() {
    const { alertCondition } = this.props;
    const { threshold } = alertCondition.parameters;
    const thresholdType = alertCondition.parameters.threshold_type.toLowerCase();
    const { time } = alertCondition.parameters;

    return (
      <span>
        Alert is triggered when there
        {' '}
        <Pluralize value={threshold}
                   singular={`is ${thresholdType} than one message`}
                   plural={`are ${thresholdType} than ${threshold} messages`} />
        {' '}in the{' '}
        <Pluralize value={time} singular="last minute" plural={`last ${time} minutes`} />.
        {' '}
        <GracePeriodSummary alertCondition={alertCondition} />
        {' '}
        <BacklogSummary alertCondition={alertCondition} />
        {' '}
        <RepeatNotificationsSummary alertCondition={alertCondition} />
      </span>
    );
  }
}

export default MessageCountConditionSummary;
